import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { BASE_URL } from '../Config';
import '../css/style/style.css';
import keepaiLogo from '../resource/keepaiLogo.png';
import chatgtp from '../resource/chatgtp.png';
import cluade1 from '../resource/cluade1.jpeg';
import foot1 from '../resource/foot1.png';
import foot2 from '../resource/foot2.png';
import foot3 from '../resource/foot3.png';
import foot4 from '../resource/foot4.png';
import PolicyModal from './PolicyModal';

const Main = () => {
    const navigate = useNavigate();
    const [query, setQuery] = useState('');
    const [activeCategory, setActiveCategory] = useState('all');
    const [services, setServices] = useState([]);
    const [loading, setLoading] = useState(false);

    const stored = localStorage.getItem('user');
    const userObj = stored ? JSON.parse(stored) : null;
    const isLoggedIn = !!userObj;
    const userName = userObj?.name || null;
    const userRole = userObj?.role || null;
    const [dropdownOpen, setDropdownOpen] = useState(false);
    const [showAuthModal, setShowAuthModal] = useState(false);
    const [roleBlocked, setRoleBlocked] = useState(false);
    const [policyType, setPolicyType] = useState(null);
    const [subscriptions, setSubscriptions] = useState({ chatgpt: false, claude: false });

    const requireAuth = () => {
        if (!isLoggedIn) { setShowAuthModal(true); return false; }
        if (userRole !== 'Y') { setRoleBlocked(true); return false; }
        return true;
    };

    const handleLogout = () => {
        localStorage.removeItem('user');
        setDropdownOpen(false);
        navigate('/login');
    };

    // 카테고리 목록
    const categories = [
        { id: 'all', name: '전체', icon: '▦' },
        { id: 'chatbot', name: 'AI 챗봇', icon: '💬' },
        { id: 'image', name: '이미지 생성', icon: '🖼' },
        { id: 'video', name: '영상 생성', icon: '🎬' },
        { id: 'audio', name: '음성 / 음악', icon: '🎵' },
        { id: 'writing', name: '글쓰기', icon: '✏️' },
        { id: 'productivity', name: '생산성', icon: '📊' },
        { id: 'dev', name: '개발', icon: '</>' },
        { id: 'design', name: '디자인', icon: '🎨' },
        { id: 'marketing', name: '마케팅', icon: '📢' },
        { id: 'etc', name: '기타', icon: '⋯' },
    ];

    // 인기 검색어
    const popularKeywords = ['ChatGPT', 'Midjourney', 'Claude', 'Notion AI', 'Runway', 'Perplexity', 'Gamma', 'Copilot'];

    // 임시 데이터 (실제로는 API에서 받아옴)
    const mockServices = [
        {
            id: 1, name: 'ChatGPT Plus', provider: 'OpenAI', category: 'chatbot',
            price: 19000,
            description: '더 똑똑해진 AI와 대화하고\n생산성을 높여보세요.',
            logo: chatgtp, logoColor: '#10A37F'
        },
        {
            id: 2, name: 'Claude Pro', provider: 'Anthropic', category: 'chatbot',
            price: 19000,
            description: '긴 문서 분석부터 코딩까지\n신뢰할 수 있는 AI 어시스턴트.',
            logo: cluade1, logoText: 'C', logoColor: '#D97757',
        },
    ];

    useEffect(() => {
        const filtered = activeCategory === 'all'
            ? mockServices
            : mockServices.filter(s => s.category === activeCategory);
        setServices(filtered);
        setLoading(false);
    }, [activeCategory]); // eslint-disable-line

    useEffect(() => {
        if (!isLoggedIn) return;
        const stored = localStorage.getItem('user');
        const token = stored ? JSON.parse(stored).token : null;
        if (!token) return;
        fetch(`${BASE_URL}/user/subscriptions`, {
            headers: { Authorization: `Bearer ${token}` },
        })
            .then(r => r.ok ? r.json() : null)
            .then(data => { if (data) setSubscriptions(data); })
            .catch(() => {});
    }, [isLoggedIn]);

    const handleSearch = () => {
        if (!query.trim()) return;
        if (!requireAuth()) return;
        navigate('/chat', { state: { query: query.trim() } });
    };

    const handleKeywordClick = (keyword) => {
        if (!requireAuth()) return;
        navigate('/chat', { state: { query: keyword } });
    };

    return (
        <div className="keepai-wrapper">
            {policyType && <PolicyModal type={policyType} onClose={() => setPolicyType(null)} />}

            {/* 이용 권한 없음 모달 */}
            {roleBlocked && (
                <div className="auth-modal-backdrop" onClick={() => setRoleBlocked(false)}>
                    <div className="auth-modal" onClick={e => e.stopPropagation()}>
                        <div className="auth-modal-icon">💳</div>
                        <h3 className="auth-modal-title">현재 유료 서비스 이용 권한이 없습니다.</h3>
                        <p className="auth-modal-desc">
                            결제 비용 : 19,000원<br/><br/>
                            <strong>※ 결제 및 이용 문의</strong><br/>
                            연락처 : 1566-2144<br/>
                        </p>
                        <div className="auth-modal-btns">
                            <button className="auth-modal-btn-login" onClick={() => navigate('/payment')}>결제하기</button>
                        </div>
                        <button className="auth-modal-close" onClick={() => setRoleBlocked(false)}>닫기</button>
                    </div>
                </div>
            )}

            {/* 비회원 차단 모달 */}
            {showAuthModal && (
                <div className="auth-modal-backdrop" onClick={() => setShowAuthModal(false)}>
                    <div className="auth-modal" onClick={e => e.stopPropagation()}>
                        <div className="auth-modal-icon">🔒</div>
                        <h3 className="auth-modal-title">회원 전용 서비스</h3>
                        <p className="auth-modal-desc">채팅 기능은 로그인 후 이용하실 수 있습니다.</p>
                        <div className="auth-modal-btns">
                            <button
                                className="auth-modal-btn-login"
                                onClick={() => navigate('/login', { state: { tab: 'login' } })}
                            >로그인</button>
                            <button
                                className="auth-modal-btn-register"
                                onClick={() => navigate('/login', { state: { tab: 'register' } })}
                            >회원가입</button>
                        </div>
                        <button className="auth-modal-close" onClick={() => setShowAuthModal(false)}>닫기</button>
                    </div>
                </div>
            )}

            {/* 헤더 */}
            <header className="keepai-header">
                <div className="header-inner">
                    <div className="logo">
                        <img src={keepaiLogo} alt={keepaiLogo}/>
                    </div>
                    <nav className="nav-menu">
                        <span className="nav-item active" onClick={() => navigate('/')}>AI 검색</span>
                    </nav>
                    <div className="header-actions">
                        {isLoggedIn ? (
                            <div className="user-menu">
                                <button className="btn-user" onClick={() => setDropdownOpen(v => !v)}>
                                    {userName}님 ▾
                                </button>
                                {dropdownOpen && (
                                    <>
                                        <div className="user-dropdown-backdrop" onClick={() => setDropdownOpen(false)} />
                                        <div className="user-dropdown">
                                            {(userRole === 'Y' || userRole === 'R') && (
                                                <button onClick={() => { setDropdownOpen(false); navigate('/rooms'); }}>단톡방</button>
                                            )}
                                            {(userRole === 'Y' || userRole === 'R') && (
                                                <button onClick={() => { setDropdownOpen(false); navigate('/schedule'); }}>공정표 생성</button>
                                            )}
                                            <button onClick={handleLogout}>로그아웃</button>
                                        </div>
                                    </>
                                )}
                            </div>
                        ) : (
                            <>
                                <button className="btn-login" onClick={() => navigate('/login')}>로그인</button>
                                <button className="btn-signup" onClick={() => navigate('/login', { state: { tab: 'register' } })}>회원가입</button>
                            </>
                        )}
                    </div>
                </div>
            </header>

            {/* 히어로 섹션 */}
            <section className="hero-section">
                <div className="hero-icons">
                    <div className="floating-icon icon-1">🤖</div>
                    <div className="floating-icon icon-2">🎨</div>
                    <div className="floating-icon icon-3">AI</div>
                    <div className="floating-icon icon-4">◆</div>
                </div>

                <h1 className="hero-title">
                    개인 검색정보 노출되면 <span className="highlight-blue">100% 환불</span><br/>
                    Chat GPT 플러스 모델이 아닐 시 <span className="highlight-purple">200% 환불 보장</span>.
                </h1>
                <p className="hero-subtitle">
                    Keep AI에서 다양한 AI 서비스를 할인된 가격으로 만나보세요.
                </p>

                {/* 검색바 */}
                <div className="search-bar">
                    <span className="search-icon">🔍</span>
                    <input
                        type="text"
                        placeholder="원하는 AI 서비스를 검색해보세요"
                        value={query}
                        onChange={(e) => { if (!requireAuth()) return; setQuery(e.target.value); }}
                        onKeyDown={(e) => { if (e.key === 'Enter') handleSearch(); }}
                        onClick={() => { if (!isLoggedIn) setShowAuthModal(true); }}
                        readOnly={!isLoggedIn}
                    />
                    <button className="search-btn" onClick={handleSearch}>검색</button>
                </div>

                {/* 인기 검색어 */}
                <div className="popular-keywords">
                    <span className="popular-label">인기 검색어</span>
                    {popularKeywords.map((kw, idx) => (
                        <button
                            key={idx}
                            className="keyword-chip"
                            onClick={() => handleKeywordClick(kw)}
                        >
                            {kw}
                        </button>
                    ))}
                </div>
            </section>

            {/* 카테고리 탭 */}
            <section className="category-section">
                <div className="category-tabs">
                    {categories.map(cat => (
                        <button
                            key={cat.id}
                            className={`category-tab ${activeCategory === cat.id ? 'active' : ''}`}
                            onClick={() => setActiveCategory(cat.id)}
                        >
                            <span className="cat-icon">{cat.icon}</span>
                            <span className="cat-name">{cat.name}</span>
                        </button>
                    ))}
                </div>
            </section>

            {/* 인기 AI 서비스 */}
            <section className="services-section">
                <div className="section-header">
                    <h2>🔥 인기 AI 서비스</h2>
                </div>

                <div className="services-grid">
                    {loading ? (
                        <div className="loading">로딩 중...</div>
                    ) : (
                        services.map(service => (
                            <div
                                key={service.id}
                                className="service-card"
                                onClick={() => { if (!isLoggedIn) navigate('/login', { state: { tab: 'register' } }); }}
                                style={{ cursor: isLoggedIn ? 'default' : 'pointer' }}
                            >
                                <div className="service-header">
                                    <div
                                        className="service-logo"
                                        style={{ backgroundColor: service.logoColor + '20', color: service.logoColor }}
                                    >
                                        {service.logo
                                            ? <img src={service.logo} alt={service.name}/>
                                            : <span className="service-logo-text">{service.logoText}</span>
                                        }
                                    </div>
                                    <div className="service-info">
                                        <h3>{service.name}</h3>
                                        <p className="provider">{service.provider}</p>
                                    </div>
                                </div>

                                <p className="service-desc">
                                    {service.description.split('\n').map((line, i) => (
                                        <React.Fragment key={i}>{line}<br/></React.Fragment>
                                    ))}
                                </p>

                                <div className="price-row">
                                    <span className="original-price">29,000원</span>
                                    <span className="discount-badge">34.5%</span>
                                    <span className="sale-price">월 {service.price.toLocaleString()}원</span>
                                </div>

                                {service.id === 2 ? (
                                    // Claude Pro 카드
                                    subscriptions.claude ? (
                                        <button
                                            className="service-pay-btn service-pay-btn--active"
                                            onClick={(e) => { e.stopPropagation(); navigate('/chat', { state: { model: 'claude' } }); }}
                                        >
                                            지금 이용하기 →
                                        </button>
                                    ) : (
                                        <button
                                            className="service-pay-btn"
                                            onClick={(e) => {
                                                e.stopPropagation();
                                                if (!isLoggedIn) { setShowAuthModal(true); return; }
                                                navigate('/payment', { state: { product: 'claude' } });
                                            }}
                                        >
                                            Claude Pro 구독하기
                                        </button>
                                    )
                                ) : (userRole === 'Y' || userRole === 'R') ? (
                                    // ChatGPT 카드 — 이미 구독 중
                                    <button
                                        className="service-pay-btn service-pay-btn--active"
                                        onClick={(e) => { e.stopPropagation(); navigate('/chat'); }}
                                    >
                                        지금 이용하기 →
                                    </button>
                                ) : (
                                    // ChatGPT 카드 — 미구독
                                    <button
                                        className="service-pay-btn"
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            if (!isLoggedIn) { setShowAuthModal(true); return; }
                                            navigate('/payment', { state: { product: 'chatgpt' } });
                                        }}
                                    >
                                        결제하기
                                    </button>
                                )}
                            </div>
                        ))
                    )}
                </div>
            </section>

            <div className="subscription-notice">
                <img src={foot1} alt={foot1}/>공유 구독이 아닙니다. 동일 서비스 할인 구독 상품입니다.
            </div>

            {/* 하단 혜택 배너 */}
            <section className="benefits-section">
                <div className="benefit-item">
                    <span className="benefit-icon">
                        <img src={foot4} alt={foot4}/>
                    </span>
                    <div>
                        <h4>최대 52% 할인</h4>
                        <p>Chat GPT가 아닐 시<br/>200% 환불 보장</p>
                    </div>
                </div>
                <div className="benefit-item">
                    <span className="benefit-icon">
                        <img src={foot1} alt={foot1}/>
                    </span>
                    <div>
                    <h4>안전한 결제</h4>
                        <p>검증된 결제 시스템으로<br/>안심하고 이용하세요</p>
                    </div>
                </div>
                <div className="benefit-item">
                    <span className="benefit-icon">
                        <img src={foot2} alt={foot2}/>
                    </span>
                    <div>
                    <h4>고객 지원</h4>
                        <p>문제 해결을 위한<br/>전문 지원을 제공합니다</p>
                    </div>
                </div>
                <div className="benefit-item">
                    <span className="benefit-icon">
                        <img src={foot3} alt={foot3}/>
                    </span>
                    <div>
                    <h4>결제없이 10회 무료 체험</h4>
                        <p>무료로 체험해보고<br/>안전하게 이용해보세요</p>
                    </div>
                </div>
            </section>

            {/* 푸터 */}
            <footer className="keepai-footer">
                <div className="footer-inner">
                    <div className="footer-links">
                        <button className="footer-link" onClick={() => setPolicyType('terms')}>이용약관</button>
                        <span className="footer-link-divider">|</span>
                        <button className="footer-link" onClick={() => setPolicyType('privacy')}>개인정보 처리방침</button>
                        <span className="footer-link-divider">|</span>
                        <button className="footer-link" onClick={() => setPolicyType('about')}>서비스 소개</button>
                    </div>
                    <div className="footer-info">
                        <p><strong>주식회사 리스트</strong> &nbsp;|&nbsp; 대표 : 김영빈 &nbsp;|&nbsp; 사업자등록번호 : 275-81-03051</p>
                        <p>주소 : 인천 남동구 은봉로 297 남동구 청년창업지원센터 310호</p>
                        <p>통신판매업 신고번호 : 제 2025-인천남동구-1259호 &nbsp;|&nbsp; 고객센터 : 1566-2144</p>
                    </div>
                    <p className="footer-copy">© 2026 Keep AI. All rights reserved.</p>
                </div>
            </footer>
        </div>
    );
};

export default Main;
